import { environment } from 'src/environments/environment';
import { isNativeShell } from '../platform/platform.service';

/**
 * Origin to use when building links meant to be shared or opened outside the app.
 * Inside the native shell `window.location.origin` is the WebView origin
 * (`fleetchaser://localhost` on iOS, `https://localhost` on Android), which is
 * useless to whoever receives the link — use the deployed console origin instead.
 */
export function getShareableAppOrigin(): string {
  if (isNativeShell() && environment.webAppUrl) {
    return environment.webAppUrl.replace(/\/+$/, '');
  }
  return window.location.origin;
}

export function buildShareableAppUrl(path: string): string {
  return new URL(
    path.startsWith('/') ? path : `/${path}`,
    getShareableAppOrigin(),
  ).toString();
}
